// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file event/v1/payment_event.proto (package event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Money } from "../../common/v1/common_pb";
import { Duration } from "../../google/protobuf/duration_pb";

/**
 * Represents the actual body of a payment event message; a payment event occurs
 * when Checkout backend calls a payment gateway.
 *
 * @generated from message event.v1.PaymentEventPayload
 */
export const PaymentEventPayload = proto3.makeMessageType(
  "event.v1.PaymentEventPayload",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "message", T: Money },
    { no: 3, name: "duration", kind: "message", T: Duration },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_gateway", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "auth_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "capture_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "create_shopper_profile", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "payment_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "proc_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "proc_status_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "host_response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "profile_status_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "profile_status_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

